/** Lead schema + validation shared by the browser form and the server handler. */

export type LeadInput = {
  kind: "contact" | "project"
  name: string
  company: string
  email: string
  phone: string
  country: string
  service: string
  description: string
  budget: string
  contactMethod: string
  consent: boolean
  /** Honeypot. Must be empty. */
  website: string
  locale: "ar" | "en"
  sourcePage: string
  utm?: Record<string, string>
}

export type LeadErrors = Partial<Record<keyof LeadInput, "required" | "invalid" | "tooLong">>

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
const PHONE = /^\+?[0-9\s\-()]{7,20}$/

export function validateLead(v: LeadInput): LeadErrors {
  const e: LeadErrors = {}
  const req = (k: keyof LeadInput) => {
    if (!String(v[k] ?? "").trim()) e[k] = "required"
  }
  req("name")
  req("email")
  req("description")
  if (v.kind === "project") {
    req("company")
    req("service")
  }
  if (v.email && !EMAIL.test(v.email.trim())) e.email = "invalid"
  if (v.phone && !PHONE.test(v.phone.trim())) e.phone = "invalid"
  if ((v.name ?? "").length > 120) e.name = "tooLong"
  if ((v.company ?? "").length > 160) e.company = "tooLong"
  if ((v.description ?? "").length > 5000) e.description = "tooLong"
  if (
    (v.description ?? "").trim().length > 0 &&
    v.description.trim().length < 10
  )
    e.description = "invalid"
  if (!v.consent) e.consent = "required"
  return e
}
